import { cn } from "@/src/lib/utils";
import { Text } from "@/src/components/ui/Typography";

import type { SectorItem } from "./data";

interface SectorRowProps {
  item: SectorItem;
  active: boolean;
  direction: "up" | "down";
  onHover: () => void;
}

export function SectorRow({ item, active, direction, onHover }: SectorRowProps) {
  return (
    <div
      id={item.slug}
      onMouseEnter={onHover}
      className="grid scroll-mt-(--header-height) cursor-default grid-cols-1 items-center gap-4 py-6 md:grid-cols-[auto_1fr_28rem] md:gap-12"
    >
      <Text
        as="span"
        size="titleLG"
        className={cn(
          "text-neutral-700 transition-colors duration-300 md:text-neutral-400",
          active && "md:text-neutral-700",
        )}
      >
        {item.title}
      </Text>

      <span
        className={cn(
          "hidden h-px origin-left scale-x-0 bg-neutral-700 opacity-0 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)] md:block",
          active && "scale-x-100 opacity-100",
        )}
      />

      <Text
        size="bodySM"
        className={cn(
          "max-w-120 text-neutral-600 opacity-100 md:opacity-0 md:transition-all md:duration-500 md:ease-[cubic-bezier(.22,1,.36,1)]",
          !active && (direction === "down" ? "md:-translate-y-4" : "md:translate-y-4"),
          active && "md:translate-y-0 md:opacity-100",
        )}
      >
        {item.description}
      </Text>
    </div>
  );
}
